import React, {useContext, useEffect, useRef, useState} from "react";
import styles from "./Login.module.css";
import {ReactComponent as YuJaLogo} from "../../images/yujalogo.svg";
import {useHistory} from "react-router-dom";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import {
    ASK_RECEIVE_LINK_TEXT,
    EMAIL, ENTER_EMAIL_TEXT,
    FORGOT_PWD_DESC,
    FORGOT_PWD_TEXT, GO_BACK_TEXT, INVALID_EMAIL_TEXT,
    REGEX_EMAIL, REQUEST_NEW_LINK_IN_TEXT, REQUEST_NEW_LINK_TEXT,
    SCREEN_TYPE, SEND_REST_LINK_TEXT, TEXTBOX,
} from "../../utils/constants";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {ReactComponent as INVALID_ICON} from "../LoginPage/images/invalid-icon.svg"
import {useCountdown} from "../../hooks/useCountdown";
import {timeSecondsToCustomNewMinutes} from "../../utils/questionUtils";
import {notifySuccess} from "../../utils/helpers";
import {RESET_EMAIL_SEND_SUCCESS} from "../../utils/toast-message-constants";
import {Button} from "@base-ui/react/button";
import {YuJaGlobalState} from "../../utils/LoadingContext";


export default function ForgotPasswordPage() {
    const [input, setInput] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [hasSent, setHasSent] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [unusableRemaining, setUnusableRemaining] = useState(0);
    const {globalHostResource: hostResource} = useContext(YuJaGlobalState);
    const {imageURL} = hostResource;
    const history = useHistory();
    const {sendResetPwdEmail} = AuthenticationApiCalls();
    const {getReturnValues, resetCountdown} = useCountdown(0);
    const [days, hours, minutes, seconds] = getReturnValues;


    const {type} = useWindowDimensions();
    const sendLinkBtnRef = useRef();

    useEffect(() => {
        if (days + hours + minutes + seconds <= 0) {
            setUnusableRemaining(0);
        } else {
            setUnusableRemaining(days * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60 + seconds)
        }
    }, [seconds]);



    const inlineStyles = {
        rowStyle: {display: "flex", alignItems: "center", gap: 5},
        inputBoxStyle: {fontSize: 15, height: 47, fontWeight: "400", padding: 12},
        linkStyle: {whiteSpace: "nowrap", textDecoration: "underline", fontSize: 16, alignSelf: "center", fontWeight: "600"},
        resendTextDescStyle: {fontSize: 15, color: "#000"},
        emphasisStyle: {fontWeight: "700"},
        remainingSecStyle: {color: "#0B6F85", fontWeight: "700", fontSize: 13, lineHeight: 1.6,},
    }

    const validateForm = () => {
        let returnVal = true;
        if (!input || input.search(REGEX_EMAIL) < 0) {
            setEmailError(INVALID_EMAIL_TEXT);
            returnVal = false;
        }
        return returnVal;
    };

    const onKeyUp = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }

    }



    const handleSubmit = () => {
        let btn = document.getElementById("YuJa-send-link-btn");
        if (btn.getAttribute("data-disabled") === "true") {
            return;
        }

        setEmailError("");
        if (!validateForm()) {
            return;
        }

        setIsSending(true);


        // setTimeout(() => {
        //     setIsSending(false);
        //     resetCountdown(Date.now() + 60 * 1000);
        //     setHasSent(true);
        // }, 3000);

        // send email
        sendResetPwdEmail(input).then((res) => {
            if (!!res) {
                notifySuccess(RESET_EMAIL_SEND_SUCCESS);
                resetCountdown(Date.now() + 60 * 1000);
                setHasSent(true);
            }
        }).finally(() => {
            setIsSending(false);
        });
    }

    const resend = async () => {
        if (!!isSending || unusableRemaining > 0) {
            return;
        }

        if (!validateForm()) {
            return;
        }

        setIsSending(true);
        // setTimeout(() => {
        //     setIsSending(false);
        //     resetCountdown(Date.now() + 60 * 1000);
        // }, 3000);


        // send email
        sendResetPwdEmail(input).then((res) => {
            notifySuccess(RESET_EMAIL_SEND_SUCCESS);
            resetCountdown(Date.now() + 60 * 1000);
        }).finally(() => {
            setIsSending(false);
        });

    }

    const editInput = (e) => {
        setInput(e.target.value)
        setEmailError("");
    }

    const goHome = () => {
        history.push({pathname: "/"});
    }



    return (
        <>
            <div
                style={{backgroundImage: !!imageURL ? `url(${imageURL})` : undefined}}
                className={!!imageURL ? styles.imageBackground : styles.gradientBackground}
            />
            <div className={`${styles.container} ${type === SCREEN_TYPE.MOBILE ? styles.mobileContainer : ""}`}>
                <div style={{flex: 1}}/>
                <div className={styles.loginCard}>
                    <div className={styles.logoContainer}>
                        <YuJaLogo/>
                        <span className={styles.mediumText}>{FORGOT_PWD_TEXT}</span>
                        <span className={styles.descriptionText}>{FORGOT_PWD_DESC}</span>
                    </div>

                    <div>
                        <div style={inlineStyles.rowStyle}>
                            <span className={styles.labelText}>{EMAIL}</span>
                            <span style={{flex: 1}}/>
                            {!!emailError &&
                                <>
                                    <INVALID_ICON/>
                                    <span className={styles.errorText}>{emailError}</span>
                                </>
                            }
                        </div>
                        <div style={{height: 10}}/>
                        <YuJaTextBox
                            containerStyle={inlineStyles.inputBoxStyle}
                            placeholder={ENTER_EMAIL_TEXT}
                            value={input}
                            onChange={e => editInput(e)}
                            onKeyUp={onKeyUp}
                            isInvalid={!!emailError}
                        />
                    </div>
                    <Button
                        id={"YuJa-send-link-btn"}
                        className={styles.signInButtonNew}
                        onClick={handleSubmit}
                        disabled={!!hasSent || !!isSending}
                        focusableWhenDisabled={!hasSent}
                    >
                        {SEND_REST_LINK_TEXT}
                    </Button>

                    {!!hasSent && !!isSending &&
                        <span className={`${styles.loadingText} ${styles.requestingText}`}>
                            {REQUEST_NEW_LINK_TEXT}
                        </span>
                    }

                    {!!hasSent && !isSending &&
                        <span style={inlineStyles.resendTextDescStyle}>
                            <span>{ASK_RECEIVE_LINK_TEXT}</span>
                            {unusableRemaining > 0
                                ?
                                <span style={{whiteSpace: "nowrap"}}>
                                    <span style={inlineStyles.emphasisStyle}>
                                        {REQUEST_NEW_LINK_IN_TEXT}
                                    </span>
                                    <span style={inlineStyles.remainingSecStyle}>
                                        {timeSecondsToCustomNewMinutes(unusableRemaining)}
                                    </span>
                                </span>
                                :
                                <Button
                                    className={styles.linkText}
                                    style={inlineStyles.linkStyle}
                                    onClick={resend}
                                >
                                    {REQUEST_NEW_LINK_TEXT}
                                </Button>

                            }

                        </span>
                    }


                        <Button
                            className={styles.linkText}
                            onClick={goHome}
                            role={TEXTBOX}
                            style={inlineStyles.linkStyle}
                        >
                            {GO_BACK_TEXT}
                        </Button>
                </div>
                <div style={{flex: 1}}/>
            </div>
        </>
    );
}
